var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.banner
    ? _c(
        "a",
        {
          directives: [
            {
              name: "tooltip",
              rawName: "v-tooltip",
              value: {
                content: _vm.banner.title + " - " + _vm.banner.description
              },
              expression:
                "{ content: `${banner.title} - ${banner.description}` }"
            }
          ],
          staticClass: "h-display-inline-block",
          attrs: { href: _vm.banner.link, target: "_blank" },
          on: { click: _vm.recordClick }
        },
        [_c("img", { attrs: { src: _vm.imageUrl } })]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }